<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-operation"></i> 空间管理</span>
      </div>
      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        :inline="true"
        label-position="right"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-form-item label="空间名称">
          <el-input
            v-model="queryParams.name"
            placeholder="请输入空间名称"
            clearable
            style="width: 250px"
          />
        </el-form-item>
        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog"
            >新增</el-button
          >
        </el-row>
      </el-form>

      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="空间名称" prop="name"></el-table-column>
        <el-table-column label="设备编号" prop="deviceNo"></el-table-column>
        <!-- <el-table-column label="管理老师" prop="teacherNames"></el-table-column> -->
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button
              type="primary"
              size="mini"
              @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="deleteDepartment(scope.row)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :title="isEdit ? '编辑空间' : '新增空间'"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="currentDepartment"
          ref="form"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item label="空间名称" prop="name">
            <el-input
              v-model="currentDepartment.name"
              placeholder="请输入空间名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="空间设备号" prop="deviceNo">
            <el-input
              v-model="currentDepartment.deviceNo"
              placeholder="请输入空间设备号"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="管理老师" prop="teachers">
            <el-select
              v-model="currentDepartment.teachers"
              placeholder="请选择管理老师"
              style="width: 100%"
              multiple
              filterable
              clearable
            >
              <el-option
                v-for="teacher in teacherOptions"
                :key="teacher.id"
                :label="teacher.name"
                :value="teacher.id"
              />
            </el-select>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">
            {{ isEdit ? "更新" : "确 定" }}
          </el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { teacherPage } from "@/api/material";
import {
  spaceList,
  spaceAddOrEdit,
  spaceDetail,
  spaceDelete,
} from "@/api/config";
import PaginationBar from "@/components/PaginationBar";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      queryParams: {
        name: "", // 查询条件
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      allData: [],
      tableData: [],
      dialogVisible: false,
      isEdit: false,
      teacherOptions: [], // 管理老师选项
      currentDepartment: {
        name: "",
        deviceNo: "", // 空间设备号
        // teachers: [], // 管理老师ID数组（改为数组）
      },
      rules: {
        name: [
          { required: true, message: "空间名称是必填项", trigger: "blur" },
        ],
        deviceNo: [
          { required: true, message: "空间设备号是必填项", trigger: "blur" },
        ],
        // teachers: [
        //   {
        //     required: true,
        //     message: "请选择管理老师",
        //     trigger: "change",
        //     type: "array",
        //   },
        // ],
      },
    };
  },
  created() {
    this.handleQuery();
    this.getTeacherList(); // 获取管理老师列表
  },
  methods: {
    // 获取管理老师列表
    getTeacherList() {
      teacherPage({
        pageNo: 1,
        pageSize: 1000,
      }).then((res) => {
        this.teacherOptions = res.records;
      });
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      const { name } = this.queryParams;
      spaceList({
        name,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams.name = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.isEdit = false;
      this.currentDepartment = {
        name: "",
        deviceNo: "",
        // teachers: [], // 初始化为空数组
      };
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      spaceDetail({
        id: row.id,
      }).then((res) => {
        this.isEdit = true;
        this.currentDepartment = {
          ...res,
          // teachers: res.teachers
          //   ? res.teachers.map((teacher) => teacher.id)
          //   : [], // 只提取id组成数组
        };
        this.dialogVisible = true;
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            name: this.currentDepartment.name,
            deviceNo: this.currentDepartment.deviceNo,
            // teachers: this.currentDepartment.teachers, // 传递数组
          };

          if (this.isEdit) {
            params.id = this.currentDepartment.id; // 编辑时传 id
          }

          spaceAddOrEdit(params).then(() => {
            this.dialogVisible = false;
            this.handleQuery();
            this.$message.success("操作成功");
          });
        } else {
          return false;
        }
      });
    },

    deleteDepartment(row) {
      this.$confirm("确定删除当前空间?", "删除提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          spaceDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          });
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
